(function() {
    function setHeaderHeightVariable() {
        const header = document.querySelector('[data-target="header"]');
        if (!header) return;
    
        const height = header.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--height-header', `${height}px`);
    }

    document.addEventListener('DOMContentLoaded', () => {
        const header = document.querySelector('[data-target="header"]');
        
        if (!header) {
            return
        };
        
        setHeaderHeightVariable();
        
        let resizeTicking = false;
        
        window.addEventListener('resize', () => {
            if (!resizeTicking) {
                requestAnimationFrame(() => {
                    setHeaderHeightVariable();
                    resizeTicking = false;
                });
                resizeTicking = true;
            }
        });

        const SCROLL_THRESHOLD = 10;
        const TOP_OFFSET = 280;
        const FIXED_CLASS = 'header_fixed';
        const HIDDEN_CLASS = 'header_scroll-hidden';

        let lastScrollY = window.scrollY;
        let ticking = false;
        let hideOnHashScroll = false;
        let hashScrollTimeout = null;

        function isRootHashLink(link) {
            const href = (link.getAttribute('href') || '').trim();

            if (/^\/#[^\s#]+/.test(href)) {
                return true;
            }

            try {
                const url = new URL(link.href, window.location.origin);

                return url.origin === window.location.origin && url.pathname === '/' && url.hash.length > 1;
            } catch (error) {
                return false;
            }
        }

        function hideHeader() {
            header.classList.add(FIXED_CLASS);
            header.classList.add(HIDDEN_CLASS);
        }

        function scheduleHashScrollEnd() {
            window.clearTimeout(hashScrollTimeout);

            hashScrollTimeout = window.setTimeout(() => {
                hideOnHashScroll = false;
                lastScrollY = window.scrollY;
            }, 200);
        }

        function startHashScrollHide() {
            hideOnHashScroll = true;

            if (window.scrollY > TOP_OFFSET) {
                hideHeader();
            }

            scheduleHashScrollEnd();
        }

        function updateHeader() {
            const scrollY = window.scrollY;

            if (hideOnHashScroll) {
                scheduleHashScrollEnd();

                if (scrollY <= TOP_OFFSET) {
                    header.classList.remove(HIDDEN_CLASS);
                    header.classList.remove(FIXED_CLASS);
                } else {
                    hideHeader();
                }

                lastScrollY = scrollY;
                ticking = false;

                return;
            }

            if (scrollY <= TOP_OFFSET) {
                header.classList.remove(HIDDEN_CLASS);
                header.classList.remove(FIXED_CLASS);
                lastScrollY = scrollY;
                ticking = false;

                return;
            }

            if (Math.abs(scrollY - lastScrollY) < SCROLL_THRESHOLD) {
                ticking = false;

                return;
            }

            if (scrollY > lastScrollY) {
                header.classList.add(HIDDEN_CLASS);
            } else {
                header.classList.add(FIXED_CLASS);
                header.classList.remove(HIDDEN_CLASS);
            }

            lastScrollY = scrollY;
            ticking = false;
        }

        document.addEventListener('click', (event) => {
            const link = event.target.closest('a[href]');

            if (link && isRootHashLink(link)) {
                startHashScrollHide();
            }
        }, true);

        window.addEventListener('scroll', () => {
            if (!ticking) {
                requestAnimationFrame(updateHeader);
                ticking = true;
            }
        }, { passive: true });
    }); 
})();